module.exports = __webpack_public_path__ + "media/images/ecommerce/product_02-a968dc06fc24ee83190c9d3d5b0acf25.svg";